import React from 'react'
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
//import { Navigate, useNavigate } from 'react-router-dom';
import Notification from "../../Notification";
export default function LetestRchargeStatus() {


    const [items, setItems] = useState([]);
    const [totalPages, setTotalPage] = useState(0);
    const [pageCount, setpageCount] = useState(0);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('')
    const [isChecked, setisChecked] = useState(false);
    // const [sorting, setSorting] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [perPage, setPerpage] = useState(process.env.REACT_APP_PER_PAGE)

    useEffect(() => {
        const getLetestRchargeStatusList = async () => {
            const res = await Axios.post(`api/business/last-transaction-history-list?pageNo=1&perPage=${perPage}`)
            console.log("hello", res);
            setItems(res.data.data[0].data);
            setTotalPage(res.data.data[0].totalPage)
            setpageCount(Math.ceil(res.data.data[0].totalPage));

        };
        getLetestRchargeStatusList();
    }, [perPage]);


    const fetchLetestRchargeStatusList = async (currentPage) => {
        const res = await Axios.post(`api/business/last-transaction-history-list?pageNo=${currentPage}&perPage=${perPage}`)
        // console.log(res)
        await setItems(res.data.data[0].data);
        return items;
    };

    const handlePageClick = async (items) => {
        console.log(items.selected);

        let currentPage = items.selected + 1;
        if (startDate && endDate) {
            await searchHandle(currentPage);
        } else {
            await fetchLetestRchargeStatusList(currentPage);
        }
    };
    const handleChange = (e) => {
        // alert("Hi");
        const { name, checked } = e.target;

        if (name === "allSelect") {
            let tempItems = items.map((countryList) => {
                return { ...countryList, isChecked: checked };
            });
            //   console.log(tempItems)
            //   return false;
            setisChecked(tempItems)
            setItems(tempItems);
        }
        else {
            let tempItems = items.map((countryList) =>
                countryList.country_id === name ? { ...countryList, isChecked: checked } : countryList
            );
            ;
            setisChecked(tempItems)
            setItems(tempItems);

        }
    }

    const searchHandle = async (currentPage) => {
        if ((startDate && endDate)) {
            const res = await Axios.post(`api/business/last-transaction-history-list?pageNo=${currentPage}&perPage=${perPage}&startDate=${startDate}&endDate=${endDate}`);
            console.log("hello", res);

            if (res.data.data[0].data.length > 0) {
                setItems(res.data.data[0].data)
                setTotalPage(res.data.data[0].totalPage)
                setpageCount(Math.ceil(res.data.data[0].totalPage));
            }
            if (res.data.data[0].data.length <= 0) {
                setItems([])
                setTotalPage(res.data.data[0].totalPage)
                setpageCount(Math.ceil(res.data.data[0].totalPage));
            }

        } else {
            setNotify({
                isOpen: true,
                messsage: `Search By and Search Value Should Not Be Blank!`,
                type: 'error',

            })
        }

    }

    return (
        <>
            <div className="content-page">
                <div className="content"><h1>{totalPages}</h1>
                    {/* <!-- Start Content--> */}
                    <div className="container-fluid">

                        {/* <!-- start page title --> */}
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">

                                    <h4 className="page-title">Latest Recharge Status</h4>
                                </div>
                            </div>
                        </div>
                        {/* <!-- end page title -->  */}

                        <div className="row">
                            <div className="col-12">
                                <div className="card-box table-responsive">
                                    {
                                        notify.isOpen ?
                                            <Notification
                                                notify={notify}
                                                setNotify={setNotify} />
                                            : ""
                                    }
                                    {/* <span><b>Search By:-</b></span> */}

                                    <form className=''>
                                        <label for="" >start date:-</label>
                                        <input type="date" id="" name="" onChange={(e) => setStartDate(e.target.value)} />&nbsp;&nbsp;
                                        <label for="" >End date:-</label>
                                        <input type="date" id="" name="" onChange={(e) => setEndDate(e.target.value)} />&nbsp;&nbsp;
                                    </form>

                                    <span>
                                        <button type="Search" className="find-list" onClick={searchHandle}>Search</button>
                                    </span>


                                    <table id="datatable" className="table table-bordered  dt-responsive nowrap" style={{ padding: "30px", margin: "20px" }}>
                                        <thead>
                                            <tr>
                                                <td><input
                                                    type="checkbox"
                                                    name="allSelect"
                                                    checked={!items.some((countryList) => countryList?.isChecked !== true)}
                                                    onChange={handleChange} /> <label className="form-check-label ms-2">All Select</label></td>

                                                <td>S.No</td>
                                                <td >Business Id</td>
                                                <td >Plan Id </td>
                                                <td >Bought Plan Id</td>
                                                <td >Business Name</td>
                                                <td >Package Name</td>
                                                <td >Price</td>
                                                <td >Added Date</td>
                                                <td >Status</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {items.map((LetestRchargeStatusList, index) =>
                                                <tr key={index}>
                                                    <td><input
                                                        type="checkbox"
                                                        name={[LetestRchargeStatusList.business_id]}
                                                        checked={LetestRchargeStatusList?.isChecked || false}
                                                        onChange={handleChange}
                                                    />  </td>
                                                    <td>{index + 1}</td>
                                                    <td>{LetestRchargeStatusList.business_id}</td>
                                                    <td>{LetestRchargeStatusList.plan_id}</td>
                                                    <td>{LetestRchargeStatusList.bought_plan_id}</td>
                                                    <td>{LetestRchargeStatusList.business_name}</td>
                                                    <td>{LetestRchargeStatusList.package_name}</td>
                                                    <td>{LetestRchargeStatusList.price}</td>
                                                    <td>{new Date(LetestRchargeStatusList.added_date).toDateString() + '' + new Date(LetestRchargeStatusList.added_date).toTimeString().split(' ')[0]}</td>
                                                    <td>{LetestRchargeStatusList.status}</td>

                                                </tr>)}
                                        </tbody>
                                    </table>
                                    <ReactPaginate
                                        previousLabel={"previous"}
                                        nextLabel={"next"}
                                        breakLabel={"..."}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={3}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination justify-content-center"}
                                        pageClassName={"page-item"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"page-item"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"page-item"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"page-item"}
                                        breakLinkClassName={"page-link"}
                                        activeClassName={"active"}
                                    />
                                    <div>
                                        <span><b>Rows per page:-</b></span>
                                        <select name="Rows per page" onChange={(e) => setPerpage(e.target.value)}>
                                            <option value="">Select Item Per Page</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="30">30</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* <!-- end row --> */}
                    </div>
                    {/* <!-- end container-fluid --> */}

                </div>
            </div>
        </>
    )
}
